module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Menus")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.$root.activeLocation && _vm.$root.activeLocation.id && _vm.$root.permissions['menu_manager menus create']) ? _c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray",
    on: {
      "click": function($event) {
        _vm.toggleCreateMenuPanel()
      }
    }
  }, [_c('div', {
    staticClass: "custom tools"
  }, [_c('a', {
    class: {
      'expand': !_vm.createMenuCollapse, 'collapse': _vm.createMenuCollapse
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\t Create A New Menu\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body",
    class: {
      'display-hide': _vm.createMenuCollapse
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createNewMenu($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-body row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'col-md-2': !_vm.imageMode.newMenu, 'col-md-12': _vm.imageMode.newMenu
    }
  }, [_c('resource-picker', {
    staticClass: "margin-top-15",
    attrs: {
      "imageButton": true,
      "imageUrl": _vm.newMenu.image_url
    },
    on: {
      "open": function($event) {
        _vm.toggleImageMode('newMenu', true)
      },
      "close": function($event) {
        _vm.toggleImageMode('newMenu', false)
      },
      "selected": _vm.updateImage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageMode.newMenu),
      expression: "!imageMode.newMenu"
    }],
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMenu.name),
      expression: "newMenu.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newMenu.name.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_2"
    },
    domProps: {
      "value": (_vm.newMenu.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newMenu, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Menu Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMenu.order),
      expression: "newMenu.order"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newMenu.order !== null
    },
    attrs: {
      "type": "number",
      "id": "form_control_3"
    },
    domProps: {
      "value": (_vm.newMenu.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newMenu, "order", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_3"
    }
  }, [_vm._v("Menu Order")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMenu.desc),
      expression: "newMenu.desc"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newMenu.desc.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_4"
    },
    domProps: {
      "value": (_vm.newMenu.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newMenu, "desc", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_4"
    }
  }, [_vm._v("Menu Description")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMenu.sku),
      expression: "newMenu.sku"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newMenu.sku.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_5"
    },
    domProps: {
      "value": (_vm.newMenu.sku)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newMenu, "sku", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_5"
    }
  }, [_vm._v("Menu SKU")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageMode.newMenu),
      expression: "!imageMode.newMenu"
    }],
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Menu Status:")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Active",
      "inactive-text": "Sold Out"
    },
    model: {
      value: (_vm.newMenu.status),
      callback: function($$v) {
        _vm.$set(_vm.newMenu, "status", $$v)
      },
      expression: "newMenu.status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Menu Type:")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Catering",
      "inactive-text": "Regular"
    },
    model: {
      value: (_vm.newMenu.catering),
      callback: function($$v) {
        _vm.$set(_vm.newMenu, "catering", $$v)
      },
      expression: "newMenu.catering"
    }
  })], 1), _vm._v(" "), (_vm.newMenu.catering) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMenu.min),
      expression: "newMenu.min"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newMenu.min.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_6"
    },
    domProps: {
      "value": (_vm.newMenu.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newMenu, "min", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_6"
    }
  }, [_vm._v("Minimum order value")])]) : _vm._e(), _vm._v(" "), (_vm.newMenu.catering) ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMenu.max),
      expression: "newMenu.max"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newMenu.max.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_7"
    },
    domProps: {
      "value": (_vm.newMenu.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newMenu, "max", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_7"
    }
  }, [_vm._v("Maximum order value")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-bottom-20"
  }, [_c('label', [_vm._v("Is an Add-on Menu:")]), _c('br'), _vm._v(" "), _c('el-switch', {
    staticClass: "margin-right-10",
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.newMenu.addon),
      callback: function($$v) {
        _vm.$set(_vm.newMenu, "addon", $$v)
      },
      expression: "newMenu.addon"
    }
  }), _vm._v(" "), (_vm.newMenu.addon === 1) ? _c('button', {
    staticClass: "btn btn-xs blue btn-outline",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.selectAddOnCategories(_vm.newMenu, $event)
      }
    }
  }, [_vm._v("Select add-on categories")]) : _vm._e(), _vm._v(" "), (_vm.newMenu.add_on.length) ? _c('p', {
    staticClass: "grey-label margin-top-10"
  }, [_vm._v("Selected " + _vm._s(_vm.newMenu.add_on.length) + " "), (_vm.newMenu.add_on.length === 1) ? _c('span', [_vm._v("category")]) : _c('span', [_vm._v("categories")])]) : _vm._e()], 1), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "From"
    },
    model: {
      value: (_vm.newMenu.start_from),
      callback: function($$v) {
        _vm.$set(_vm.newMenu, "start_from", $$v)
      },
      expression: "newMenu.start_from"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t"), _c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "To"
    },
    model: {
      value: (_vm.newMenu.stop_on),
      callback: function($$v) {
        _vm.$set(_vm.newMenu, "stop_on", $$v)
      },
      expression: "newMenu.stop_on"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imageMode.newMenu),
      expression: "!imageMode.newMenu"
    }],
    staticClass: "form-actions right margin-top-20"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])])]) : _vm._e(), _vm._v(" "), (!_vm.$root.activeLocation.id) ? _c('div', {
    staticClass: "alert alert-info center margin-top-20"
  }, [_c('h4', [_vm._v("No Store Selected")]), _vm._v(" "), _c('p', [_vm._v("Please select a store from the stores panel on the right to view its menus")])]) : _vm._e(), _vm._v(" "), (_vm.$root.activeLocation && _vm.$root.activeLocation.id) ? _c('div', [_c('div', {
    staticClass: "portlet light portlet-fit bordered margin-top-20"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "btn-group-vertical pull-right",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn blue btn-xs",
    class: {
      'active': _vm.menuFilter === '0', 'btn-outline': _vm.menuFilter !== '0'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuFilter),
      expression: "menuFilter"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.menuFilter, "0")
    },
    on: {
      "change": function($event) {
        _vm.menuFilter = "0"
      }
    }
  }), _vm._v(" Regular Menus ")]), _vm._v(" "), _c('label', {
    staticClass: "btn blue btn-xs",
    class: {
      'active': _vm.menuFilter === '1', 'btn-outline': _vm.menuFilter !== '1'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuFilter),
      expression: "menuFilter"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.menuFilter, "1")
    },
    on: {
      "change": function($event) {
        _vm.menuFilter = "1"
      }
    }
  }), _vm._v(" Catering Menus ")]), _vm._v(" "), _c('label', {
    staticClass: "btn blue btn-xs",
    class: {
      'active': _vm.menuFilter === '2', 'btn-outline': _vm.menuFilter !== '2'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menuFilter),
      expression: "menuFilter"
    }],
    staticClass: "toggle",
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.menuFilter, "2")
    },
    on: {
      "change": function($event) {
        _vm.menuFilter = "2"
      }
    }
  }), _vm._v(" Add-on Menus ")])])]), _vm._v(" "), (_vm.$root.activeLocation && _vm.$root.activeLocation.id && !_vm.displayMenuData) ? _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listErrorMessage.length),
      expression: "listErrorMessage.length"
    }],
    ref: "listErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('listErrorMessage')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.listErrorMessage))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$root.activeLocation.is_corporate),
      expression: "$root.activeLocation.is_corporate"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.menuTiers !== null) ? _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "Select Tier",
      "clearable": true
    },
    on: {
      "change": function($event) {
        _vm.updateList()
      }
    },
    model: {
      value: (_vm.indexOfTierToDisplay),
      callback: function($$v) {
        _vm.indexOfTierToDisplay = $$v
      },
      expression: "indexOfTierToDisplay"
    }
  }, _vm._l((_vm.menuTiers), function(tier, index) {
    return _c('el-option', {
      key: tier.id,
      attrs: {
        "label": tier.name,
        "value": index
      }
    })
  })) : _vm._e()], 1)]), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.displayMenuData,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (!_vm.storeMenus.length && !_vm.displayMenuData) ? _c('div', [_c('no-results', {
    attrs: {
      "show": !_vm.storeMenus.length,
      "type": 'menus',
      "custom": true,
      "text": _vm.customText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-element-list margin-top-15"
  }, [_c('div', {
    staticClass: "mt-list-container list-news ext-1 no-border"
  }, [_c('ul', _vm._l((_vm.storeMenus), function(menu) {
    return _c('li', {
      key: menu.id,
      staticClass: "mt-list-item margin-top-15 clickable",
      class: {
        'animated': _vm.animated === ("menu-" + (menu.id))
      },
      attrs: {
        "id": 'menu-' + menu.id
      },
      on: {
        "click": function($event) {
          _vm.viewMenuCategories(menu)
        }
      }
    }, [_c('div', {
      staticClass: "margin-bottom-15 actions-on-top"
    }, [(_vm.$root.permissions['menu_manager menus update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Edit",
        "effect": "light",
        "placement": "top"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editMenu(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus read'] && !_vm.$root.permissions['menu_manager menus update']) ? _c('el-tooltip', {
      attrs: {
        "content": "View",
        "effect": "light",
        "placement": "top"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.editMenu(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-eye"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Menu Hours",
        "effect": "light",
        "placement": "top"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.showMenuHours(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-clock-o"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Apply Add-on Category",
        "effect": "light",
        "placement": "top"
      }
    }, [(_vm.menuFilter !== '2') ? _c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.applyAddOnCategories(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "icon-layers"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus update'] && _vm.$root.activeLocation.is_corporate) ? _c('el-tooltip', {
      attrs: {
        "content": "Duplicate",
        "effect": "light",
        "placement": "top"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.duplicateMenu(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-clone"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.activeLocation.is_corporate && _vm.$root.permissions['menu_manager menus update']) ? _c('el-tooltip', {
      attrs: {
        "content": "Copy",
        "effect": "light",
        "placement": "top"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.copyMenu(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-files-o"
    })])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus delete']) ? _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "effect": "light",
        "placement": "top"
      }
    }, [_c('a', {
      staticClass: "btn btn-circle btn-icon-only btn-default",
      on: {
        "click": function($event) {
          _vm.deleteMenu(menu, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })])]) : _vm._e()], 1), _vm._v(" "), _vm._m(3, true, false), _vm._v(" "), _c('div', {
      staticClass: "list-thumb"
    }, [(menu.image_url.length) ? _c('a', [_c('img', {
      attrs: {
        "alt": "",
        "src": menu.image_url
      }
    })]) : _c('a', [_c('img', {
      attrs: {
        "src": require("../../../assets/img/app/image-placeholder.png")
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "list-datetime bold uppercase font-red"
    }, [_c('span', [_vm._v(_vm._s(menu.name))])]), _vm._v(" "), _c('div', {
      staticClass: "list-item-content row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('strong', [_vm._v("Description:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(menu.desc))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Status:")]), _vm._v(" "), (menu.status == 1) ? _c('span', [_vm._v("Available")]) : _vm._e(), _vm._v(" "), (menu.status == 0) ? _c('span', [_vm._v("Sold Out")]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.start_from || menu.stop_on),
        expression: "menu.start_from || menu.stop_on"
      }],
      staticClass: "col-md-4"
    }, [_c('strong', [_vm._v("From:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(menu.start_from))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("To:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(menu.stop_on))]), _c('br')])])])
  }))])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.addOnCategoriesModalActive) ? _c('apply-add-on-categories', {
    attrs: {
      "passedMenu": _vm.passedMenu
    },
    on: {
      "closeAddOnCategoriesModal": _vm.closeAddOnCategoriesModal,
      "updateAddOnCategories": _vm.updateAddOnCategories
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMenuModalActive) ? _c('edit-menu', {
    attrs: {
      "passedMenuId": _vm.passedMenuId
    },
    on: {
      "closeEditMenuModal": _vm.closeEditMenuModal,
      "updateMenu": _vm.updateMenu
    }
  }) : _vm._e(), _vm._v(" "), (_vm.menuHoursModalActive) ? _c('menu-hours', {
    attrs: {
      "menu": _vm.menuToAssignHoursTo
    },
    on: {
      "closeHoursModal": _vm.closeMenuHoursModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.duplicateMenuModalActive) ? _c('duplicate-menu', {
    attrs: {
      "passedMenuId": _vm.passedMenuId
    },
    on: {
      "closeDuplicateMenuModal": _vm.closeDuplicateMenuModal,
      "duplicateSuccess": _vm.confirmDuplicateSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.copyMenuModalActive) ? _c('copy-menu', {
    attrs: {
      "passedMenuId": _vm.passedMenuId
    },
    on: {
      "closeCopyMenuModal": _vm.closeCopyMenuModal,
      "copySuccess": _vm.confirmCopySuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deleteMenuModalActive) ? _c('delete-menu', {
    attrs: {
      "passedMenuId": _vm.passedMenuId
    },
    on: {
      "closeDeleteMenuModal": _vm.closeDeleteMenuModal,
      "deleteMenuAndCloseModal": _vm.deleteMenuAndCloseModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Manage a store's menus.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/client_logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("Menus")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("Click on a menu to view its categories.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-icon-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36eeb3a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Menu.vue
// module id = 701
// module chunks = 0